/* DON'T EDIT THIS FILE: edit original and run build again */ import { customAlphabet } from "nanoid";

const alphabet = "0123456789abcdefghijklmnopqrstuvwxyz";

export const generateId: () => string = customAlphabet(alphabet, 8);

export const generateLongId: () => string = customAlphabet(alphabet, 20);

export const generateVeryLongId: () => string = customAlphabet(alphabet, 40);
